import numeral from "numeral";

export const formatDate = (d) => {
  if (!d) {
    return "";
  }
  const date = new Date(d);
  return `${date.getFullYear()}-${numeral(date.getMonth() + 1).format(
    "00"
  )}-${numeral(date.getDate()).format("00")}`;
};
